export default __webpack_public_path__ + "static/media/rating_web-md@1x.0ca6f14d.jpg";